"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
var guid_typescript_1 = require("guid-typescript");
var StackTrace = require("stacktrace-js");
var _1 = require(".");
var useGlobal_1 = require("./useGlobal");
var loadLocalStorageValue = function (deserialize, serialize) { return function (index, initialValue) {
    var localVal = window.localStorage.getItem(index);
    var parsedVal;
    if (localVal === null) {
        window.localStorage.setItem(index, serialize(initialValue));
        parsedVal = initialValue;
    }
    else {
        try {
            parsedVal = deserialize(localVal);
        }
        catch (e) {
            parsedVal = initialValue;
        }
    }
    return parsedVal;
}; };
var saveLocalStorageValue = function (serialize) { return function (newValue, oldVal, index) {
    window.localStorage.setItem(index, serialize(newValue));
}; };
var useLocalStorageRaw = function (options) {
    var save = saveLocalStorageValue(options.serialize);
    var loadInitialValue = loadLocalStorageValue(options.deserialize, options.serialize);
    return function (initialValue, i) {
        var isRendering = StackTrace.getSync().filter(function (s) { return s.functionName === "renderWithHooks"; }).length > 0;
        if (isRendering && typeof i === "undefined") {
            throw _1.indexErrorMessage;
        }
        var initial = (!!i ? i : initialValue);
        var index = (!!i ? initialValue : guid_typescript_1.Guid.create().toString());
        var f = useGlobal_1.addSharedState(index, function () { return useGlobal_1.useGlobal({ loadInitialValue: loadInitialValue })(index, initial); });
        f.onChange(save);
        return f;
    };
};
useLocalStorageRaw.string = useLocalStorageRaw({ deserialize: function (a) { return a; }, serialize: function (a) { return a; } });
useLocalStorageRaw.number = useLocalStorageRaw({ deserialize: function (a) { return +a; }, serialize: function (a) { return "" + a; } });
useLocalStorageRaw.boolean = useLocalStorageRaw({ deserialize: function (a) { return !!a; }, serialize: function (a) { return a ? "1" : ""; } });
useLocalStorageRaw.object = function (initial, i) {
    return useLocalStorageRaw({ deserialize: JSON.parse, serialize: JSON.stringify })(initial, i);
};
exports.useLocalStorage = useLocalStorageRaw;
